import reducer from "./reducers";

import * as symptomsActions from "./actions";

export { symptomsActions };

export default reducer;
